export default __webpack_public_path__ + "static/media/Sunday_02.bf84ab57.png";